(function($, root, undefined) {
    $(function() {
        /**
         * Our people bio popup
         *
         */
        $(".about-our-people__item-link").click(function() {

            var id = $(this).data("id");

            $("#about-our-people__popup--" + id).addClass("about-our-people__popup--active");
            $(".about-our-people__popup-overlay").addClass("about-our-people__popup-overlay--active");

            $("html, body").css("overflow-y", "hidden");
            $("body").append("<div class='lightbox-overlay'></div>");

        });

        $(document).on('click', ".about-our-people__popup-overlay, .about-our-people__popup-close", function(e) {
                e.preventDefault();
            $(".about-our-people__popup-overlay").removeClass("about-our-people__popup-overlay--active");
            $(".about-our-people__popup").removeClass("about-our-people__popup--active");

            $("html, body").css("overflow-y", "auto");
            $(".lightbox-overlay").remove();
        });

    });
  
})(jQuery, this);
